// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3MDPN","actions":"styles_actions__3ykn1","area":"styles_area__2bgMX","userID":"styles_userID__3O4TX","input":"styles_input__3XQOB"};